import { computed, defineAsyncComponent, defineComponent } from 'vue';

export default defineComponent({
  name: 'BackgroundComponent',
  components: {
    AsyncPlainComponent: defineAsyncComponent(() => import('./plain/Plain.vue')),
    AsyncBubbleComponent: defineAsyncComponent(() => import('./bubble/Bubble.vue')),
    AsyncLeafComponent: defineAsyncComponent(() => import('./leaf/Leaf.vue')),
    AsyncFireflyComponent: defineAsyncComponent(() => import('./firefly/Firefly.vue')),
  },
  props: {
    theme: {
      type: [String as () => 'plain' | 'bubble' | 'leaf' | 'firefly'],
      default: () => 'plain',
    },
  },
  setup: (props) => {
    const background = computed(() => `async-${props.theme}-component`);

    return {
      background,
    };
  },
});
